import { AdminLegalAlertsMexicoColaboradorLoading } from '@/views/admin-legal-alerts-mexico-colaborador/admin-legal-alerts-mexico-colaborador.loading';

export default AdminLegalAlertsMexicoColaboradorLoading;
